declare namespace $ {

	type $mol_button_major__title_shm_mentionstat_items_1 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_items['merge_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_mentionstat_items_2 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_items['merge_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_mentionstat_items_3 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_items['merge_start'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_text__text_shm_mentionstat_items_4 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_items['status_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_minor__hint_shm_mentionstat_items_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_mentionstat_items_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_mentionstat_items_7 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_items['item_edit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__hint_shm_mentionstat_items_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_mentionstat_items_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_mentionstat_items_10 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_items['item_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_grid__records_shm_mentionstat_items_11 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_items['records'] >
		,
		ReturnType< $mol_grid['records'] >
	>
	type $mol_grid__col_ids_shm_mentionstat_items_12 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_items['col_ids'] >
		,
		ReturnType< $mol_grid['col_ids'] >
	>
	type $mol_grid__col_head_content_shm_mentionstat_items_13 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_items['col_head_content'] >
		,
		ReturnType< $mol_grid['col_head_content'] >
	>
	type $mol_grid__cell_content_shm_mentionstat_items_14 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_items['cell_content'] >
		,
		ReturnType< $mol_grid['cell_content'] >
	>
	type $mol_grid__Cell_shm_mentionstat_items_15 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_items['Cell'] >
		,
		ReturnType< $mol_grid['Cell'] >
	>
	type $mol_grid__Col_head_shm_mentionstat_items_16 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_items['Col_head'] >
		,
		ReturnType< $mol_grid['Col_head'] >
	>
	type $mol_view__sub_shm_mentionstat_items_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_mentionstat_items_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_grid_cell__sub_shm_mentionstat_items_19 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_items['cell_content'] >
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__style_shm_mentionstat_items_20 = $mol_type_enforce<
		({ 
			'width': ReturnType< $shm_mentionstat_items['cell_width'] >,
			'minWidth': ReturnType< $shm_mentionstat_items['cell_width'] >,
			'maxWidth': ReturnType< $shm_mentionstat_items['cell_width'] >,
		})  & ReturnType< $mol_grid_cell['style'] >
		,
		ReturnType< $mol_grid_cell['style'] >
	>
	type $mol_float__sub_shm_mentionstat_items_21 = $mol_type_enforce<
		ReturnType< $shm_mentionstat_items['col_head_content'] >
		,
		ReturnType< $mol_float['sub'] >
	>
	type $mol_float__style_shm_mentionstat_items_22 = $mol_type_enforce<
		({ 
			'width': ReturnType< $shm_mentionstat_items['col_width'] >,
			'minWidth': ReturnType< $shm_mentionstat_items['col_width'] >,
			'maxWidth': ReturnType< $shm_mentionstat_items['col_width'] >,
		})  & ReturnType< $mol_float['style'] >
		,
		ReturnType< $mol_float['style'] >
	>
	type $mol_view__sub_shm_mentionstat_items_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_mentionstat_items extends $mol_page {
		body_rows( ): readonly(any)[]
		records( ): readonly(any)[]
		col_ids( ): readonly(any)[]
		col_head_content( id: any): readonly(any)[]
		cell_content( id: any): readonly(any)[]
		merge_start( next?: any ): any
		Merge( ): $mol_button_major
		Status( ): $mol_text
		cell_width( id: any): string
		col_width( id: any): string
		Edit_icon( id: any): $mol_icon_edit
		item_edit( id: any, next?: any ): any
		Edit( id: any): $mol_button_minor
		Delete_icon( id: any): $mol_icon_trash_can
		item_delete( id: any, next?: any ): any
		Delete( id: any): $mol_button_minor
		title( ): string
		item_ids( ): readonly(any)[]
		item_query( id: any): string
		item_excluded( id: any): string
		item_period( id: any): string
		item_country( id: any): string
		item_language( id: any): string
		item_social( id: any): string
		item_mass( id: any): string
		item_type( id: any): string
		item_tags( id: any): string
		item_category( id: any): string
		merge_title( ): string
		merge_enabled( ): boolean
		status_text( ): string
		body( ): ReturnType< $shm_mentionstat_items['body_rows'] >
		Grid( ): $mol_grid
		Empty( ): $mol_view
		Controls( ): $mol_view
		Cell( id: any): $mol_grid_cell
		Col_head( id: any): $mol_float
		Actions( id: any): $mol_view
	}
	
}

//# sourceMappingURL=items.view.tree.d.ts.map